<template>
	<v-alert
		v-if="visible"
		type="info"
		outlined
		dense
		class="mb-4"
	>
		<v-icon
			slot="prepend"
			color="info"
		>
			mdi-information
		</v-icon>
		This user's information is centrally managed and syncs automatically.
		<!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
		Please update their details in your organisation's user management system<template v-if="ssoConfigurationName"> (<strong>{{ ssoConfigurationName }}</strong>)</template>.
	</v-alert>
</template>

<script>
export default {
	name: 'scim-managed-notice',
	props: {
		scimExternalId: {
			type: String,
			default: null
		},
		scimEnabled: {
			type: Boolean,
			default: false
		},
		ssoConfigurationName: {
			type: String,
			default: ''
		},
		isScimManaged: {
			type: [Boolean, null],
			default: null
		}
	},
	computed: {
		visible () {
			// If isScimManaged is explicitly provided, use it; otherwise calculate from individual props
			if (this.isScimManaged !== null) {
				return this.isScimManaged
			}
			return this.scimEnabled && this.scimExternalId && this.scimExternalId.trim() !== ''
		}
	}
}
</script>
